import { CSSObject } from '@emotion/react';

export const wrap: CSSObject = {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
};

export const trigger: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '35px',
  height: '35px',
  borderRadius: '4px',
  cursor: 'pointer',
  ':hover': { backgroundColor: '#f7f7f7' },
};

export const menu: CSSObject = {
  zIndex: 10,
  backgroundColor: '#fff',
  padding: '12px 8px',
  borderRadius: '4px',
  boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
};

export const list: CSSObject = {
  minWidth: '160px',
};

export const item = (disabled: boolean): CSSObject => ({
  padding: '8px',
  fontSize: '12px',
  whiteSpace: 'nowrap',
  cursor: disabled ? 'not-allowed' : 'pointer',
  color: disabled ? '#b2b2b4' : 'inherit',
  ':hover': { backgroundColor: disabled ? 'transparent' : '#f7f7f7' },
});
